'use server';

import { createClient } from '@/lib/supabase/server';
import { AuthSchema } from '@/lib/schemas';
import { cookies } from 'next/headers';

export async function signIn(formData: FormData) {
    const validatedFields = AuthSchema.safeParse({
        email: formData.get('email'),
        password: formData.get('password'),
    });

    if (!validatedFields.success) {
        return { success: false, error: validatedFields.error.issues[0].message };
    }

    const { email, password } = validatedFields.data;
    const supabase = await createClient();

    try {
        const { error } = await supabase.auth.signInWithPassword({
            email,
            password,
        });

        if (error) {
            return { success: false, error: error.message };
        }

        const cookieStore = await cookies();
        if (email.toLowerCase().trim() === 'demo@inni.cl') {
            cookieStore.set('is_demo', 'true', {
                path: '/',
                httpOnly: false,
                secure: true,
                maxAge: 60 * 60 * 24 * 7 // 7 días
            });
        } else {
            cookieStore.set('is_demo', '', { path: '/', maxAge: 0 });
        }
    } catch (error: any) {
        // Ignorar errores de redirección de Next.js
        if (error.digest?.includes('NEXT_REDIRECT')) throw error;
        return { success: false, error: error.message || 'Error al iniciar sesión' };
    }

    return { success: true };
}

export async function signUp(formData: FormData) {
    const validatedFields = AuthSchema.safeParse({
        email: formData.get('email'),
        password: formData.get('password'),
    });

    if (!validatedFields.success) {
        return { success: false, error: validatedFields.error.issues[0].message };
    }

    const { email, password } = validatedFields.data;
    const supabase = await createClient();

    try {
        const { error } = await supabase.auth.signUp({
            email,
            password,
        });

        if (error) {
            return { success: false, error: error.message };
        }
    } catch (error: any) {
        if (error.digest?.includes('NEXT_REDIRECT')) throw error;
        return { success: false, error: error.message || 'Error al registrarse' };
    }

    // Redirigir con mensaje de éxito
    return { success: true };
}

export async function signOutAction() {
    const supabase = await createClient();
    await supabase.auth.signOut();
    const cookieStore = await cookies();
    cookieStore.set('is_demo', '', { path: '/', maxAge: 0 });
    return { success: true };
}
